import { AfterViewInit, Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { Router } from '@angular/router';
import { UserService } from '../../service/user.service';
import { TranslateService } from '@ngx-translate/core';
import { QueryRef } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
  Query,
  GetUsersQuery,
  GetUsersGQL,
  CreateUserGQL,
  User,
  MeGQL,
} from '../../../generated/graphql';
import { GetEmployeeByReGQL } from 'graphql/employee/employee.definition';
import { GetEmployeeByReQuery } from 'src/app/model/employee';

declare var $: any;

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent
  extends BaseComponent
  implements OnInit, AfterViewInit
{
  title = 'web';

  users: Observable<Query['getUsers']>;
  usersQuery: QueryRef<GetUsersQuery>;
  getEmployeeByReQuery: QueryRef<GetEmployeeByReQuery>;
  modelUser: any = {};

  constructor(
    public router: Router,
    public translate: TranslateService,
    public meGQL: MeGQL,
    private getUsersGQL: GetUsersGQL,
    private createUserGQL: CreateUserGQL,
    public userService: UserService,
    private employeeGQL: GetEmployeeByReGQL
  ) {
    super(router, translate);
  }

  ngOnInit(): void {
    const re = localStorage.getItem('re');

    if (localStorage.getItem('culture') === 'pt-BR') {
      this.switchLanguage('pt');
    }
    if (localStorage.getItem('culture') === 'en-US') {
      this.switchLanguage('en');
    }
    if (localStorage.getItem('culture') === 'es-ES') {
      this.switchLanguage('es');
    }
    if (this.isNullOrUndefined(localStorage.getItem('culture'))) {
      super.switchLanguage('pt');
    }

    this.usersQuery = this.getUsersGQL.watch();
    this.users = this.usersQuery.valueChanges.pipe(
      map((result) => result.data.getUsers)
    );

    const isAuthenticated = this.userService.getStatusAuthenticated();

    if (isAuthenticated && !re) {
      this.getCurrentUser();
    } else if (isAuthenticated && re) {
      this.getCurrentEmployee(re);
    }

    setTimeout(() => {
      super.toggleLoader(false);
    }, 1000);
  }

  ngAfterViewInit(): void {
    $(document).on('show.bs.modal', '.modal', function () {
      $(this).appendTo('body');
      const zIndex = 1040 + 10 * $('.modal:visible').length;
      $(this).css('z-index', zIndex);
      setTimeout(() => {
        $('.modal-backdrop')
          .not('.modal-stack')
          .css('z-index', zIndex - 1)
          .addClass('modal-stack');
      }, 0);
    });
  }

  onCreateUser() {
    if (
      this.isNullOrUndefined(this.modelUser.email) ||
      this.isNullOrUndefined(this.modelUser.password) ||
      this.isNullOrUndefined(this.modelUser.role)
    ) {
      this.showMessage(
        this.translate.instant('attention'),
        this.translate.instant('fields')
      );
      return;
    }

    this.createUserGQL
      .mutate({
        input: {
          name: this.modelUser.name,
          email: this.modelUser.email,
          role: this.modelUser.role,
        },
      })
      .subscribe(() => {
        this.modelUser = {};
        this.usersQuery.refetch();
      });
  }

  getCurrentUser() {
    this.meGQL.watch().valueChanges.subscribe({
      next: ({ data }) => {
        if (data && data.me) {
          this.userService.updateUser(data.me as User);
        } else {
          this.showMessage(
            this.translate.instant('attention'),
            this.translate.instant('UserNotFound'),
            'warning'
          );
        }
      },
      error: (error) => {
        this.router.navigate(['/logout'])
        console.error('Error fetching current user:', error);
        //this.showMessage(
        //  this.translate.instant('attention'),
        //  this.translate.instant('UserFetchError'),
        //  'warning'
        //);
      },
    });
  }

  getCurrentEmployee(re: string) {
    this.getEmployeeByReQuery = this.employeeGQL.watch({ re });
    this.getEmployeeByReQuery.valueChanges.subscribe({
      next: ({ data }) => {},
      error: () => {
        this.showMessage(
          this.translate.instant('attention'),
          this.translate.instant('ReError'),
          'warning'
        );
      },
    });
  }
}
